import { getStartedSurveyForm, initSurveyForm, onFormSubmitted } from './survey-form.js';

export function initOnboarding() {
	getStartedSurveyForm();
	initSurveyForm();
	onFormSubmitted();
}
